import { observable, action, makeObservable } from "mobx";

class LayerStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  _st_layer_delivery_err_msg = "";

  get getDeliveryErrMsg() {
    return this._st_layer_delivery_err_msg;
  }
  @action
  setDeliveryErrMsg(msg) {
    this._st_layer_delivery_err_msg = msg;
  }

  /**
   * 주문취소실패사유
   */
  @observable
  _st_layer_fail_err_msg = "";

  get getFailErrMsg() {
    return this._st_layer_fail_err_msg;
  }
  @action
  setFailErrMsg(msg) {
    this._st_layer_fail_err_msg = msg;
  }

  /**
   * 주문취소사유
   */
  @observable
  _st_layer_deposit_check = "";

  get getDepositCheck() {
    return this._st_layer_deposit_check;
  }
  @action
  setDepositCheck(info) {
    this._st_layer_deposit_check = info;
  }

  @observable
  _st_layer_order_cancel_view = false;

  get getLayerOrderCancelView() {
    return this._st_layer_order_cancel_view;
  }
  @action
  setLayerOrderCancel(viewBl) {
    this._st_layer_order_cancel_view = viewBl;
  }

  /**
   * 주문완료
   */
  @observable
  _st_layer_order_complete_view = false;

  get getLayerOrderCompleteView() {
    return this._st_layer_order_complete_view;
  }
  @action
  setLayerOrderComplete(viewBl) {
    this._st_layer_order_complete_view = viewBl;
  }

  /**
   * 주문거절사유
   */
  @observable
  _st_layer_order_reject_view = false;

  get getLayerOrderRejectView() {
    return this._st_layer_order_reject_view;
  }
  @action
  setLayerOrderReject(viewBl) {
    this._st_layer_order_reject_view = viewBl;
  }

  /**
   * 거절-품절처리
   */
  @observable
  _st_layer_sold_out_view = false;

  get getLayerSoldOutView() {
    return this._st_layer_sold_out_view;
  }
  @action
  setLayerSoldOut(viewBl) {
    this._st_layer_sold_out_view = viewBl;
  }

  /**
   * 재출력
   */
  @observable
  _st_layer_print_setting_type = "";

  get getLayerPrintSetType() {
    return this._st_layer_print_setting_type;
  }
  @action
  setLayerPrintSetType(val) {
    this._st_layer_print_setting_type = val;
  }

  /**
   * 재출력문구
   */
  @observable
  _st_layer_reprint_view = false;

  get getLayerReprintView() {
    return this._st_layer_reprint_view;
  }
  @action
  setLayerReprint(viewBl) {
    this._st_layer_reprint_view = viewBl;
  }

  /**
   * 고객예상수령시간
   */
  @observable
  _st_layer_cst_expect_time_view = false;

  get getLayerCstExpectTimeView() {
    return this._st_layer_cst_expect_time_view;
  }
  @action
  setLayerCstExpectTime(viewBl) {
    this._st_layer_cst_expect_time_view = viewBl;
  }

  /**
   * 요기요 고객예상수령시간
   */
  @observable
  _st_layer_cst_expect_time_ygy_view = false;

  get getLayerCstExpectTimeYgyView() {
    return this._st_layer_cst_expect_time_ygy_view;
  }
  @action
  setLayerCstExpectTimeYgy(viewBl) {
    this._st_layer_cst_expect_time_ygy_view = viewBl;
  }

  /**
   * 배달요청
   */
  @observable
  _st_layer_delivery_call_view = false;

  get getLayerDeliveryCallView() {
    return this._st_layer_delivery_call_view;
  }
  @action
  setLayerDeliveryCall(viewBl) {
    this._st_layer_delivery_call_view = viewBl;
  }

  /**
   * 주소검색
   */
  @observable
  _st_layer_address_search_view = false;

  get getLayerAddressSearchView() {
    return this._st_layer_address_search_view;
  }
  @action
  setLayerAddressSearch(viewBl) {
    this._st_layer_address_search_view = viewBl;
  }

  /**
   * 수금확인
   */
  @observable
  _st_layer_check_deposit_view = false;

  get getLayerCheckDepositView() {
    return this._st_layer_check_deposit_view;
  }
  @action
  setLayerCheckDeposit(viewBl) {
    this._st_layer_check_deposit_view = viewBl;
  }

  /**
   * CID 결제 확인 알림창
   */
  @observable
  _st_layer_order_payment_alert_view = false;

  get getLayerOrderPaymentAlertView() {
    return this._st_layer_order_payment_alert_view;
  }
  @action
  setLayerOrderPaymentAlertView(viewBl) {
    this._st_layer_order_payment_alert_view = viewBl;
  }

  /**
   * 우딜-자동변경
   */
  @observable
  _st_layer_woori_change_view = false;

  get getLayerWooriChangeView() {
    return this._st_layer_woori_change_view;
  }
  @action
  setLayerWooriChange(viewBl) {
    this._st_layer_woori_change_view = viewBl;
  }

  /**
   * 알림(확인창)
   */
  @observable
  _st_layer_alert_view = false;

  get getLayerAlertView() {
    return this._st_layer_alert_view;
  }
  @action
  setLayerAlertView(viewBl) {
    this._st_layer_alert_view = viewBl;
  }

  /**
   * 공통 알림창(확인) 노출
   * @type {string}
   * @private
   */
  @observable
  _st_layer_alert_type = "";

  get getLayerAlertType() {
    return this._st_layer_alert_type;
  }
  @action
  setLayerAlertType(viewBl) {
    this._st_layer_alert_type = viewBl;
  }

  /**
   * 고객 전달예정시간 저장용
   * @type {string}
   * @private
   */
  @observable
  _st_change_cst_time = "";

  get getChangeCstTime() {
    return this._st_change_cst_time;
  }
  @action
  setChangeCstTime(viewBl) {
    this._st_change_cst_time = viewBl;
  }

  /**
   * 고객 취소,거절 사유 저장용
   * @type {string}
   * @private
   */
  @observable
  _st_change_cancel_reason = "";

  get getChangeCancelReason() {
    return this._st_change_cancel_reason;
  }
  @action
  setChangeCancelReason(viewBl) {
    this._st_change_cancel_reason = viewBl;
  }

  /**
   * 공통 알림 커스텀 메시지 타이틀
   * @type {string}
   * @private
   */
  @observable
  _st_alert_custom_title = "";

  get getAlertCustomTitle() {
    return this._st_alert_custom_title;
  }
  @action
  setAlertCustomTitle(title) {
    this._st_alert_custom_title = title;
  }

  /**
   * 공통 알림 커스텀 메시지
   * @type {string}
   * @private
   */
  @observable
  _st_alert_custom_message = "";

  get getAlertCustomMessage() {
    return this._st_alert_custom_message;
  }
  @action
  setAlertCustomMessage(message) {
    this._st_alert_custom_message = message;
  }

  /**
   * 메뉴 품절 종류(confirm , cancel)
   * @type {string}
   * @private
   */
  @observable
  _st_layer_soldOut_confirm_type = "";

  get getLayerSoldOutConfirmType() {
    return this._st_layer_soldOut_confirm_type;
  }
  @action
  setLayerSoldOutConfirmType(type) {
    this._st_layer_soldOut_confirm_type = type;
  }
  /**
   * 메뉴 품절 (확인창)
   */
  @observable
  _st_layer_soldOut_confirm_view = false;

  get getLayerSoldOutConfirmView() {
    return this._st_layer_soldOut_confirm_view;
  }
  @action
  setLayerSoldOutConfirmView(viewBl) {
    this._st_layer_soldOut_confirm_view = viewBl;
  }

  /**
   * 자체배달원 레이어창
   */
  @observable
  _st_layer_delivery_self_view = false;

  get getLayerDeliverySelfView() {
    return this._st_layer_delivery_self_view;
  }
  @action
  setLayerDeliverySelfView(viewBl) {
    this._st_layer_delivery_self_view = viewBl;
  }

  /**
   * 자체배달원 수정 레이어창
   */
  @observable
  _st_layer_delivery_self_edit_view = false;

  get getLayerDeliverySelfEditView() {
    return this._st_layer_delivery_self_edit_view;
  }
  @action
  setLayerDeliverySelfEditView(viewBl) {
    this._st_layer_delivery_self_edit_view = viewBl;
  }

  /**
   * 요청메시지 삭제 레이어창
   */
  @observable
  _st_layer_request_memo_delete_view = false;

  get getLayerRequestMemoDeleteView() {
    return this._st_layer_request_memo_delete_view;
  }
  @action
  setLayerRequestMemoDeleteView(viewBl) {
    this._st_layer_request_memo_delete_view = viewBl;
  }

  /**
   * 사용자설정 구분 (order, sound)
   */
  @observable
  _st_layer_use_set_type_view = "order";

  get getLayerUseSetTypeView() {
    return this._st_layer_use_set_type_view;
  }
  @action
  setLayerUseSetTypeView(type) {
    this._st_layer_use_set_type_view = type;
  }

  /**
   * 주문접수설정 구분 (receipt, direct)
   */
  @observable
  _st_layer_receipt_set_type_view = "receipt";

  get getLayerReceiptSetTypeView() {
    return this._st_layer_receipt_set_type_view;
  }
  @action
  setLayerReceiptSetTypeView(type) {
    this._st_layer_receipt_set_type_view = type;
  }

  /**
   * 프린트설정 구분 (receipt, direct)
   */
  @observable
  _st_layer_print_set_type_view = "default";

  get getLayerPrintSetTypeView() {
    return this._st_layer_print_set_type_view;
  }
  @action
  setLayerPrintSetTypeView(type) {
    this._st_layer_print_set_type_view = type;
  }

  /**
   * 요청메시지 구분 (kitchen, customer)
   */
  @observable
  _st_layer_request_memo_type_view = "kitchen";

  get getLayerRequestMemoTypeView() {
    return this._st_layer_request_memo_type_view;
  }
  @action
  setLayerRequestMemoTypeView(type) {
    this._st_layer_request_memo_type_view = type;
  }

  /**
   * Loading
   */
  @observable
  _st_layer_loading_view = true;

  get getLayerLoadingView() {
    return this._st_layer_loading_view;
  }
  @action
  setLayerLoadingView(viewBl) {
    this._st_layer_loading_view = viewBl;
  }

  /**
   * PAYTYPECHECK
   */

  @observable
  _st_layer_all_completed_paid_list = [];

  get getAllCompletedPaidList() {
    return this._st_layer_all_completed_paid_list;
  }
  @action
  setAllCompletedPaidList(list) {
    this._st_layer_all_completed_paid_list = list;
  }

  @observable
  _st_layer_all_completed_nopaid_list = [];

  get getAllCompletedNoPaidList() {
    return this._st_layer_all_completed_nopaid_list;
  }
  @action
  setAllCompletedNoPaidList(list) {
    this._st_layer_all_completed_nopaid_list = list;
  }

  /**
   * onboarding
   */
  @observable
  _st_layer_onboarding_view = false;

  get getLayerOnboardingView() {
    return this._st_layer_onboarding_view;
  }
  @action
  setLayerOnboardingView(viewBl) {
    this._st_layer_onboarding_view = viewBl;
  }

  /**
   * onboarding step
   */
  @observable
  _st_onboarding_step = "";

  get getChangeOnboardingStep() {
    return this._st_onboarding_step;
  }
  @action
  setChangeOnboardingStep(viewBl) {
    this._st_onboarding_step = viewBl;
  }

  /**
   * 매출수기등록
   */
  @observable
  _st_layer_salewrite_view = false;

  get getLayerSaleWriteView() {
    return this._st_layer_salewrite_view;
  }
  @action
  setLayerSaleWriteView(viewBl) {
    this._st_layer_salewrite_view = viewBl;
  }

  /**
   * 매출수기등록 필수값체크
   */
  @observable
  _st_layer_required_alert = {
    view: false,
    txt: "",
  };

  get getLayerRequiredAlert() {
    return this._st_layer_required_alert;
  }

  @action
  setLayerRequiredAlert(key, value) {
    this._st_layer_required_alert = { ...this._st_layer_required_alert, [key]: value };
  }

  /**
   * 매출수기등록 취소버튼
   */
  @observable
  _st_layer_salewrite_close_view = {
    view: false,
    confirm: false,
    id: "",
  };

  get getLayerSaleWriteCloseView() {
    return this._st_layer_salewrite_close_view;
  }
  @action
  setLayerSaleWriteCloseView(key, value) {
    this._st_layer_salewrite_close_view = { ...this._st_layer_salewrite_close_view, [key]: value };
  }

  /**
   * 문의하기 팝업
   */
  @observable
  _st_layer_cs_view = false;

  get getLayerCsView() {
    return this._st_layer_cs_view;
  }
  @action
  setLayerCsView(viewBl) {
    this._st_layer_cs_view = viewBl;
  }

  /**
   * 프린터 추가
   */
  @observable
  _st_print_add_view = false;

  get getPrintAddView() {
    return this._st_print_add_view;
  }
  @action
  setPrintAddView(viewBl) {
    this._st_print_add_view = viewBl;
  }

  /**
   * 프린터 추가 select box
   */
  @observable
  _st_print_add_select_view = false;

  get getPrintAddSelectView() {
    return this._st_print_add_select_view;
  }
  @action
  setPrintAddSelectView(viewBl) {
    this._st_print_add_select_view = viewBl;
  }

  /**
   * 개인정보 처리방침
   */
  @observable
  _st_layer_cs_agree_view = false;

  get getLayerCsAgreeView() {
    return this._st_layer_cs_agree_view;
  }
  @action
  setLayerCsAgreeView(viewBl) {
    this._st_layer_cs_agree_view = viewBl;
  }

  /**
   * 상품매출상세조회
   */
  @observable
  _st_layer_product_detailSales_view = false;

  get getLayerProductDetailView() {
    return this._st_layer_product_detailSales_view;
  }
  @action
  setLayerProductDetailView(viewBl) {
    this._st_layer_product_detailSales_view = viewBl;
  }

  /**
   * 누락상품매출조회
   */
  @observable
  _st_layer_product_etcSales_view = false;

  get getLayerProductEtcView() {
    return this._st_layer_product_etcSales_view;
  }
  @action
  setLayerProductEtcView(viewBl) {
    this._st_layer_product_etcSales_view = viewBl;
  }

  /**
   * 관리자 인증 팝업
   */
  @observable
  _st_layer_auth_view = false;

  get getLayerAuthView() {
    return this._st_layer_auth_view;
  }
  @action
  setLayerAuthView(viewBl) {
    this._st_layer_auth_view = viewBl;
  }

  /**
   * 관리자 여부
   */
  @observable
  _st_manager_auth = {
    manager: "",
    auth: "",
  };

  get getManagerAuthView() {
    return this._st_manager_auth;
  }

  @action
  setManagerAuthView(key, value) {
    this._st_manager_auth = { ...this._st_manager_auth, [key]: value };
  }

  /**
   * 연동가능 배달대행사 팝업
   */
  @observable
  _st_layer_dlv_connect_pop = false;

  get getLayerDlvConnectPop() {
    return this._st_layer_dlv_connect_pop;
  }
  @action
  setLayerDlvConnectPop(viewBl) {
    this._st_layer_dlv_connect_pop = viewBl;
  }

  /**
   * 배달대행사 연동하기
   */
  @observable
  _st_layer_dlv_connect_view = false;

  get getLayerDlvConnectView() {
    return this._st_layer_dlv_connect_view;
  }
  @action
  setLayerDlvConnectView(viewBl) {
    this._st_layer_dlv_connect_view = viewBl;
  }

  /**
   * 배달대행사 연동하기 추가
   */
  @observable
  _st_dlv_connect_add = false;

  get getDlvConnectAdd() {
    return this._st_dlv_connect_add;
  }
  @action
  setDlvConnectAdd(viewBl) {
    this._st_dlv_connect_add = viewBl;
  }

  /**
   * 배달대행사 연동하기 결과팝업
   */
  @observable
  _st_dlv_connect_result_view = false;

  get getDlvConnectResultView() {
    return this._st_dlv_connect_result_view;
  }
  @action
  setDlvConnectResultView(viewBl) {
    this._st_dlv_connect_result_view = viewBl;
  }

  /**
   * 배달대행사 연동하기 상점 목록 팝업
   */
  @observable
  _st_layer_dlv_connect_shop_view = false;

  get getLayerDlvConnectShopView() {
    return this._st_layer_dlv_connect_shop_view;
  }

  @action
  setLayerDlvConnectShopView(viewBl) {
    this._st_layer_dlv_connect_shop_view = viewBl;
  }

  /**
   * 원산지입력 팝업
   */
  @observable
  _st_layer_origin_view = false;

  get getLayerOriginView() {
    return this._st_layer_origin_view;
  }
  @action
  setLayerOriginView(viewBl) {
    this._st_layer_origin_view = viewBl;
  }

  /**
   * 시간대별그래프 bar Click
   */
  @observable
  _st_time_bar_click = false;

  get getTimeBarClick() {
    return this._st_time_bar_click;
  }
  @action
  setTimeBarClick(viewBl) {
    this._st_time_bar_click = viewBl;
  }

  /**
   * 매출분석 help
   */
  @observable
  _st_layer_help_view = false;

  get getLayerHelpView() {
    return this._st_layer_help_view;
  }
  @action
  setLayerHelpView(viewBl) {
    this._st_layer_help_view = viewBl;
  }

  /**
   * 배민연동 지난주문 정보보기
   */
  @observable
  _st_layer_baemin_endOrder_view = false;

  get getLayerBaeminEndOrderView() {
    return this._st_layer_baemin_endOrder_view;
  }
  @action
  setLayerBaeminEndOrderView(viewBl) {
    this._st_layer_baemin_endOrder_view = viewBl;
  }

  /**
   * 주문접수 및 연동 연동하기 버튼
   */
  @observable
  _st_layer_connect_view = false;

  get getLayerConnectView() {
    return this._st_layer_connect_view;
  }
  @action
  setLayerConnectView(viewBl) {
    this._st_layer_connect_view = viewBl;
  }

  /**
   * 포스 선택 팝업
   */
  @observable
  _st_layer_pospick_view = false;

  get getLayerPosPickView() {
    return this._st_layer_pospick_view;
  }
  @action
  setLayerPosPickView(viewBl) {
    this._st_layer_pospick_view = viewBl;
  }

  /**
   * 연동 완료 팝업
   */
  @observable
  _st_layer_complete_view = false;

  get getLayerCompleteView() {
    return this._st_layer_complete_view;
  }
  @action
  setLayerCompleteView(viewBl) {
    this._st_layer_complete_view = viewBl;
  }

  /**
   * 연동 매장 확인
   */
  @observable
  _st_layer_confirm_view = false;

  get getLayerConfirmView() {
    return this._st_layer_confirm_view;
  }
  @action
  setLayerConfirmView(viewBl) {
    this._st_layer_confirm_view = viewBl;
  }

  // tp
  @observable
  tp = "";

  @action
  title() {
    const titleMap = {
      YGY: "요기요",
      YGY_FAIL: "요기요",
      YGY_ERR: "요기요",
      BMN: "배달의민족",
      JNJ: "배달의진주",
      NBG: "누비고",
      HPD: "헝그리판다",
      WMP: "위메프오",
      DDY: "땡겨요",
      DDY_ERR: "땡겨요",
      MKB: "먹깨비",
      OTA: "올때아아",
      OTA_FAIL: "올때아아",
      NAVERBOOKING: "네이버",
      NAVERCONNECT: "Npay 커넥트",
    };

    return titleMap[this.tp];
  }

  @action
  setDlvConnectTypeView(viewBl) {
    this.tp = viewBl;
  }

  /**
   * 사업자번호 조회 실패 시 모달에 표시할 메시지 (false면 미표시)
   */
  @observable
  _st_layer_bizNo = false;

  get getLayerBizNo() {
    return this._st_layer_bizNo;
  }
  @action
  setLayerBizNo(messageOrClear) {
    this._st_layer_bizNo = messageOrClear;
  }

  /**
   * 연락처 실패여부
   */
  @observable
  _st_layer_phoneNo = false;

  get getLayerPhoneNo() {
    return this._st_layer_phoneNo;
  }
  @action
  setLayerPhoneNo(viewBl) {
    this._st_layer_phoneNo = viewBl;
  }

  /**
   * 배달앱 매핑 연동/해제
   */
  @observable
  _st_mapping_action = true;

  get getMappingAction() {
    return this._st_mapping_action;
  }
  @action
  setMappingAction(viewBl) {
    this._st_mapping_action = viewBl;
  }

  /**
   * 요기요 연동및해제 선택item
   */
  @observable
  _st_ygy_shop_item = {
    vendorId: "",
    vendorNm: "",
  };

  get getYgyShopItem() {
    return this._st_ygy_shop_item;
  }

  @action
  setYgyShopItem(key, value) {
    this._st_ygy_shop_item = { ...this._st_ygy_shop_item, [key]: value };
  }

  /**
   * 연동 출력물 설정 (주문전표/주문서)
   */
  @observable
  _st_print_out_type = "HALL";

  get getPrintOutType() {
    return this._st_print_out_type;
  }
  @action
  setPrintOutType(viewBl) {
    this._st_print_out_type = viewBl;
  }

  /**
   * 스크롤 disabled
   */
  @observable
  _st_scroll_disabled = {
    up: true,
    down: false,
  };

  get getScrollDisabled() {
    return this._st_scroll_disabled;
  }

  setScrollDisabled(key, value) {
    this._st_scroll_disabled = { ...this._st_scroll_disabled, [key]: value };
  }

  /**
   * 반품매출 미처리 버튼
   */
  @observable
  _st_return_fail_btn = false;

  get getReturnFailBtn() {
    return this._st_return_fail_btn;
  }
  @action
  setReturnFailBtn(viewBl) {
    this._st_return_fail_btn = viewBl;
  }

  /**
   * 반품매출 미처리 목록
   */
  @observable
  _st_return_fail_view = false;

  get getReturnFailView() {
    return this._st_return_fail_view;
  }
  @action
  setReturnFailView(viewBl) {
    this._st_return_fail_view = viewBl;
  }

  /**
   * 요기요 연동하기 버튼 클릭
   */
  @observable
  _st_ygy_connect_btn = false;

  get getYgyConnectBtn() {
    return this._st_ygy_connect_btn;
  }
  @action
  setYgyConnectBtn(viewBl) {
    this._st_ygy_connect_btn = viewBl;
  }

  /**
   * 부분취소안내
   */
  @observable
  _st_layer_partial_cancel_view = false;

  get getLayerPartialCancelView() {
    return this._st_layer_partial_cancel_view;
  }
  @action
  setLayerPartialCancelView(viewBl) {
    this._st_layer_partial_cancel_view = viewBl;
  }

  /**
   * 부분취소
   */
  @observable
  _st_layer_partial_cancel_type = {
    type: "",
    mobileOrderNo: "",
  };

  get getLayerPartialCancelType() {
    return this._st_layer_partial_cancel_type;
  }

  setLayerPartialCancelType(key, value) {
    this._st_layer_partial_cancel_type = { ...this._st_layer_partial_cancel_type, [key]: value };
  }

  /**
   * 미완료메뉴 버튼
   */
  @observable
  _st_incomplete_menu_btn = false;

  get getIncompleteMenu() {
    return this._st_incomplete_menu_btn;
  }
  @action
  setIncompleteMenu(viewBl) {
    this._st_incomplete_menu_btn = viewBl;
  }

  /**
   * 알림톡 남은 수량
   */
  @observable
  _st_alarm_call = {
    failMsg: "",
    msg: "",
    code: "",
  };

  get getAlarmCallMsg() {
    return this._st_alarm_call;
  }
  @action
  setAlarmCallMsg(key, value) {
    this._st_alarm_call = { ...this._st_alarm_call, [key]: value };
  }

  /**
   * 신규주문 알림팝업 거부버튼 체크
   */
  @observable
  _st_posnotify_reject_btn = false;

  get getPosnotiReject() {
    return this._st_posnotify_reject_btn;
  }
  @action
  setPosnotiReject(viewBl) {
    this._st_posnotify_reject_btn = viewBl;
  }

  /*
   *  CommonModal
   */
  @observable
  _st_common_modal_view = false;
  get getCommonModalView() {
    return this._st_common_modal_view;
  }
  @action
  setCommonModalView(viewBl) {
    this._st_common_modal_view = viewBl;
  }
}

export default new LayerStore();
